// Utility function to parse SMS conversation data
export const parseSMSMessage = (message: string) => {
  // Parse format: "[2025-08-05 17:17:52] Sales Rep (TJ): ok ok ok ok"
  const match = message.match(/^\[([^\]]+)\]\s*(.+?):\s*([\s\S]+)$/);
  if (!match) {
    return {
      timestamp: null,
      author: 'Unknown',
      content: message,
      isCustomer: false,
    };
  }

  const [, timestamp, author, content] = match;
  const isCustomer = !author.includes('Sales Rep');

  return {
    timestamp,
    author: author
      .replace('Sales Rep (', '')
      .replace(')', '')
      .replace('Customer', 'Customer'),
    content,
    isCustomer,
  };
};
